import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "../../forms/Form";
import FormInput from "../../forms/FormInput";
import LoadingSpinner from "../../LoadingSpinner";
import Modal from "../Modal";
import { CategoryState } from "../../../utils/CategoryState";
import { RequestState } from "../../../utils/RequestState";
import styles from "./ReleasePreview.module.scss";
import SonicLink from "../../routing/SonicLink";

type PreviewProps = {
  children: React.ReactNode;
  message: string;
  targetName?: string;
  modalLink: string;
  activeModal: CategoryState;
  requestState: RequestState;
  closeModal: () => void;
  showModal: (modal: CategoryState) => void;
  handleSubmit: (approve: boolean) => void;
  handleInputChange: (value: string) => void;
  isLoading: boolean;
  confirmations?: string;
  releaseType?: string;
  editLink?: { text: string; link: string };
};

const ReleasePreview: React.FC<PreviewProps> = ({
  children,
  message,
  targetName,
  modalLink,
  activeModal,
  requestState,
  closeModal,
  showModal,
  handleSubmit,
  handleInputChange,
  isLoading,
  confirmations,
  releaseType,
  editLink,
}) => {
  return (
    <>
      <div className={styles["f-releasePreview"]}>
        {isLoading === true ? (
          <LoadingSpinner space={1} admin_page={true} />
        ) : (
          <>
            <div className={styles["f-releasePreview__head"]}>
              <div className={styles["f-releasePreview__head__title"]}>
                公開前プレビュー
              </div>
              <div className={styles["f-releasePreview__head__min-title"]}>
                {releaseType}
              </div>
              <div className={styles["f-releasePreview__head__name"]}>
                {targetName}
              </div>
            </div>
            {confirmations !== undefined ? (
              <div className={styles["f-releasePreview__head"]}>
                {confirmations ? (
                  <>
                    <div
                      className={styles["f-releasePreview__head__min-title"]}
                    >
                      質問事項
                    </div>
                    <div
                      className={
                        styles["f-releasePreview__head__confirmations"]
                      }
                    >
                      {confirmations}
                    </div>
                  </>
                ) : (
                  "質問事項なし"
                )}
              </div>
            ) : null}
            <div className={styles["f-releasePreview__content"]}>
              {children}
            </div>
            <div className={styles["f-releasePreview__bottom"]}>
              <button
                className={styles["f-releasePreview__bottom-approval"]}
                onClick={() => showModal(CategoryState.Approval)}
              >
                <FontAwesomeIcon icon={["far", "circle"]} />
                承認&amp;公開
              </button>
              <button
                className={styles["f-releasePreview__bottom-fix"]}
                onClick={() => showModal(CategoryState.Fix)}
              >
                <FontAwesomeIcon icon={["fal", "times"]} />
                修正依頼
              </button>
            </div>
          </>
        )}
      </div>
      {
        //  承認確認
        activeModal === CategoryState.Approval &&
        requestState === RequestState.Pending ? (
          <Modal
            closeModal={closeModal}
            handler={() => handleSubmit(true)}
            categoryState={activeModal}
            headText="承認&amp;公開"
            buttonText="公開する"
          >
            承認するとSELeCTのサービス上に一般公開され、
            <br />
            審査依頼者に公開の通知が送られます。
          </Modal>
        ) : //  承認完了
        activeModal === CategoryState.Approval &&
          requestState === RequestState.Success ? (
          <Modal
            closeModal={closeModal}
            handler={() => history.back()}
            categoryState={activeModal}
            requestState={requestState}
            headText="承認&amp;公開が完了しました"
            linkText="ページを見る"
            to={modalLink}
          >
            {targetName}の承認&amp;公開が完了しました。
            <br />
            審査依頼者に公開の通知が送られました。
            {editLink ? (
              <SonicLink to={editLink.link}>{editLink.text}</SonicLink>
            ) : null}
          </Modal>
        ) : //  修正依頼
        activeModal === CategoryState.Fix &&
          requestState === RequestState.Pending ? (
          <Modal
            closeModal={closeModal}
            handler={() => handleSubmit(false)}
            categoryState={activeModal}
            headText="修正依頼"
            buttonText="修正依頼する"
          >
            <p className={styles["f-releasePreview__fixText"]}>
              修正依頼をするとステータスが『修正依頼』に変更され、
              <br />
              審査依頼者に修正依頼の通知が送られます。
            </p>
            <Form handler={() => handleSubmit(false)}>
              <FormInput
                type="textarea"
                label=""
                name="sonic_message"
                handler={handleInputChange}
                style_class={styles["f-releasePreview__textarea"]}
                placeholder="修正依頼の詳細を入力してください。"
              />
            </Form>
          </Modal>
        ) : //  修正依頼完了
        activeModal === CategoryState.Fix &&
          requestState === RequestState.Success ? (
          <Modal
            closeModal={closeModal}
            handler={() => history.back()}
            categoryState={activeModal}
            requestState={requestState}
            headText="修正依頼完了"
          >
            <p className={styles["f-releasePreview__fixText"]}>
              {targetName}の修正依頼が完了しました。
            </p>
            {message ? (
              <>
                <p className={styles["f-releasePreview__fixText"]}>
                  以下の修正依頼内容が、依頼者に送られました。
                </p>
                <div className={styles["f-releasePreview__sent"]}>
                  {message}
                </div>
              </>
            ) : null}
          </Modal>
        ) : null
      }
    </>
  );
};

export default ReleasePreview;
